import React from 'react';

import classes from './CategoriesList.css';
import CategoryItem from '../CategoryItem/CategoryItem';
// import BSMexicoLogo from '../../assets/logos/benito-santos-mexico.svg';
// import BSNoviasLogo from '../../assets/logos/benito-santos-novias.svg';
// import BSReadyToWearLogo from '../../assets/logos/benito-santos-ready-to-wear.svg';
// import TailorMadeImage from '../../assets/images/cat-tailor-made.png';
// import BridesImage from '../../assets/images/cat-brides.png';
// import ReadyToWearImage from '../../assets/images/cat-ready-to-wear.png';

const categoriesList = props => {
    const imageOrigin = `${
        process.env.REACT_APP_API_URL
    }/api/containers/files/download/`;

    return (
        <ul
            className={classes.CategoriesList}
            onMouseEnter={props.mouseEnter}
            onMouseLeave={props.mouseLeave}
        >
            {props.items.length > 0 ? (
                props.items.map((category, index) => {
                    const imageURL =
                        category.image.length > 0
                            ? imageOrigin + category.image[0].name
                            : '';

                    const logoURL =
                        category.logo.length > 0
                            ? imageOrigin + category.logo[0].name
                            : '';

                    return (
                        <CategoryItem
                            key={index}
                            logo={logoURL}
                            name={category.name}
                            image={imageURL}
                            link={`/colecciones/${category.slug}`}
                            gold={category.slug === 'novias'}
                        />
                    );
                })
            ) : (
                <div style={{ marginTop: 40 }}>Cargando...</div>
            )}
        </ul>
    );
};

export default categoriesList;



// WEBPACK FOOTER //
// ./src/components/CategoriesList/CategoriesList.js